import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, computed } from 'vue';
import TuiButton from '../Button.vue';
import SvgIcon from '../SvgIcon.vue';
import CloseIcon from '../../icons/CloseIcon.vue';
import { isMobile } from '../../../../utils/environment';
import useZIndex from '../../../../hooks/useZIndex';

type BeforeCloseFn = () => void;

interface Props {
  title: string;
  message: string;
  callback?: BeforeCloseFn | null;
  confirmButtonText: string;
  remove: Function;
  appendToBody?: boolean;
  appendToRoomContainer?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: { default: '' },
    message: { default: '' },
    callback: { type: [Function, null], default: null },
    confirmButtonText: { default: '' },
    remove: { type: Function, default: () => {} },
    appendToBody: { type: Boolean, default: false },
    appendToRoomContainer: { type: Boolean, default: false }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, message: string, callback: BeforeCloseFn | null, confirmButtonText: string, remove: Function, appendToBody: boolean, appendToRoomContainer: boolean }

const visible = ref(false);
const overlayContentStyle = ref({});
const { nextZIndex } = useZIndex();
const messageRef = ref();
const teleportDisable = computed(() => !props.appendToBody);



watch(visible, (val) => {
  if (val) {
    overlayContentStyle.value = { zIndex: nextZIndex() };
    if (props.appendToRoomContainer) {
      document.getElementById('roomContainer')?.appendChild(messageRef.value);
    }
  }
});



function handleClose() {
  props.callback && props.callback();
  doClose();
}

function doClose() {
  visible.value = false;
  props.remove();
  emit('close');
}

function handleOverlayClick(event: any) {
  if (event.target !== event.currentTarget) {
    return;
  }
  handleClose();
}

function onOpen() {
  visible.value = true;
}
onMounted(async () => {
  onOpen();
});

return { __sfc: true,visible, overlayContentStyle, nextZIndex, messageRef, teleportDisable, props, emit, handleClose, doClose, handleOverlayClick, onOpen, TuiButton, SvgIcon, CloseIcon, isMobile }
}

})